import { useState } from "react";

import { useTranslation } from "@/i18n";
import { PageHeader } from "@/components/shared/page-header";
import {
  ComplianceTabs,
  type ComplianceTab,
} from "@/components/compliance/compliance-tabs";
import { CompliancePostureTab } from "@/components/compliance/compliance-posture-tab";
import { ComplianceFrameworksTab } from "@/components/compliance/compliance-frameworks-tab";
import { ComplianceGapsTab } from "@/components/compliance/compliance-gaps-tab";
import { ComplianceEvidenceTab } from "@/components/compliance/compliance-evidence-tab";
import { ComplianceMaturityTab } from "@/components/compliance/compliance-maturity-tab";

export default function CompliancePage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<ComplianceTab>("posture");

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("compliance.page.title")}
        description={t("compliance.page.description")}
      />

      <ComplianceTabs value={tab} onChange={setTab} />

      {tab === "posture" && <CompliancePostureTab />}
      {tab === "frameworks" && <ComplianceFrameworksTab />}
      {tab === "gaps" && <ComplianceGapsTab />}
      {tab === "evidence" && <ComplianceEvidenceTab />}
      {tab === "maturity" && <ComplianceMaturityTab />}
    </div>
  );
}
